// src/components/documents/ui/DocumentDetailModalUI.tsx
import { cn } from "@/lib/utils"
import type { ReactNode, HTMLAttributes } from "react"

export const documentDetailModalTheme = {
  mainContainer: "flex flex-col h-full bg-purple-950/80 backdrop-blur-2xl border border-purple-300/40 rounded-3xl overflow-hidden shadow-2xl shadow-purple-500/20",

  header: "px-6 py-5 bg-purple-950/70 backdrop-blur-2xl border-b border-purple-300/40 text-white",

  sidebar: "w-[40%] border-r border-purple-300/30 bg-purple-950/60 backdrop-blur-xl p-6 overflow-y-auto no-scrollbar",

  section: "bg-purple-950/70 border border-purple-300/40 rounded-3xl p-5",

  fileCard: "flex items-center justify-between bg-gradient-to-br from-fuchsia-700/95 to-purple-800/85 border border-fuchsia-600/50 rounded-3xl p-5 hover:brightness-105 transition-all duration-200",

  statusBadge: "text-xl px-6 py-2 bg-emerald-600/80 text-white rounded-2xl",

  actionButtons: "flex gap-4 mt-8",

  approveButton: "flex-1 h-16 bg-gradient-to-r from-emerald-600 to-emerald-700 hover:from-emerald-700 hover:to-emerald-800 text-xl font-medium shadow-lg shadow-emerald-900/50 transition-all active:scale-[0.985] rounded-3xl",

  reworkButton: "flex-1 h-16 bg-gradient-to-r from-rose-600 to-orange-600 hover:from-rose-700 hover:to-orange-700 text-xl font-medium shadow-lg shadow-rose-900/50 transition-all active:scale-[0.985] rounded-3xl",

  chatContainer: "flex-1 flex flex-col min-h-0 bg-purple-950/40 relative",
} as const